import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  hasErrors: false,
  type: "",
  messages: "",
  data:{},
  error: {},
};
const capexOverviewSlice = createSlice({
  name: "CapexOverview",
  initialState,
  reducers: {
    getFailure: (state, { payload }) => ({
      ...state,
      hasErrors: true,
      type: payload.type,
      messages: payload.messages,
      error: payload,
    }),
    getSuccess: (state, { payload }) => ({
     ...state,
      hasErrors: false,
      type: payload.type,
      messages: payload.messages,
      data: payload.guruDtoList,
    }),
    resetState: (state) => ({
      ...state,
      hasErrors: false,
      type: "",
      messages: "",
      error: {},
      data:{}
    }),
  },
});

// eslint-disable-next-line max-len
export const {
  getFailure,
  getSuccess,
  resetState,
} = capexOverviewSlice.actions;

// A selector
export const capexOverviewSelector = (state) => state.capexOverview;

// The reducer
export default capexOverviewSlice.reducer;
